import { render } from "./TreeMap.vue?vue&type=template&id=069afbc5"
import script from "./TreeMap.vue?vue&type=script&lang=js"
export * from "./TreeMap.vue?vue&type=script&lang=js"

import "./TreeMap.vue?vue&type=style&index=0&id=069afbc5&lang=scss"
script.render = render

export default script